module.exports = __webpack_public_path__ + "static/media/kahf.2e48503b.png";